import { COLORS } from "../../../../../config/themes/colors";

export type SectionGroupButtonColor = 'red' | 'yellow' | 'blue' | 'light-blue' | 'ochre' | 'default';

export enum BUTTON_COLOR {
    RED = 'red',
    YELLOW = 'yellow',
    BLUE = 'blue',
    LIGHT_BLUE = 'light-blue',
    OCHRE = 'ochre',
    DEFAULT = 'default',
} 

interface ButtonColors {
    backgroundColor:    string;
    iconColor:          string;
}

const redColor: ButtonColors = {
    backgroundColor: COLORS.accents.dark_red[30],
    iconColor: COLORS.accents.dark_red[100]
};

const yellowColor: ButtonColors = {
    backgroundColor: COLORS.accents.yellow_ochre[30],
    iconColor: COLORS.accents.yellow_ochre[100]
};

const blueColor: ButtonColors = {
    backgroundColor: COLORS.accents.blue[30],
    iconColor: COLORS.accents.blue[100]
};

const lightBlueColor: ButtonColors = {
    backgroundColor: COLORS.accents.light_blue[30],
    iconColor: COLORS.accents.light_blue[100]
};

const ochreColor: ButtonColors = {
    backgroundColor: COLORS.accents.ochre[30],
    iconColor: COLORS.accents.ochre[100]
}

const defaultColor: ButtonColors = {
    backgroundColor: COLORS.neutrals[30],
    iconColor: COLORS.secondary[100]
};

export const getColorsSectionGroupButton = (color: SectionGroupButtonColor): ButtonColors => {
    if(color === BUTTON_COLOR.RED) return redColor;

    if(color === BUTTON_COLOR.YELLOW) return yellowColor;
    
    if(color === BUTTON_COLOR.LIGHT_BLUE) return lightBlueColor;

    if(color === BUTTON_COLOR.BLUE) return blueColor;

    if(color === BUTTON_COLOR.OCHRE) return ochreColor;

    return defaultColor;
}